"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InstallationPanelBodyV2 = void 0;

var _preact = require("preact");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _PanelItems = require("@insided/deprecated-control/integrations/components/PanelItems");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Message = require("@insided/deprecated-control/ui-components/Message");

var InstallationPanelBody = function InstallationPanelBody(props) {
  var _props$appName = props.appName,
      appName = _props$appName === void 0 ? 'Gainsight Communities Data Lake Connector' : _props$appName,
      isInstalled = props.isInstalled,
      isLoading = props.isLoading,
      credentials = props.credentials,
      onGenerateAccessKeys = props.onGenerateAccessKeys,
      onClickUninstall = props.onClickUninstall,
      onClickCopy = props.onClickCopy,
      isAthenaDataAvailable = props.isAthenaDataAvailable;
  return (0, _preact.h)("div", {
    className: "panel-body-container installation__panel_body"
  }, (0, _preact.h)("div", {
    className: "panel-body-title"
  }, "To connect to ", appName, " you will need to generate:"), (0, _preact.h)("div", {
    className: "panel-body-description"
  }, (0, _preact.h)("ul", {
    className: "panel-body-description-unordered-list"
  }, (0, _preact.h)("li", null, "Amazon Web Services (AWS) access keys (access key ID and secret access key). For more information, see", ' ', (0, _preact.h)("a", {
    href: "https://docs.aws.amazon.com/IAM/latest/UserGuide/security-creds.html#access-keys-and-secret-access-keys",
    target: "_blank",
    rel: "noreferrer",
    className: "overview-page-link"
  }, "Access keys"), ' ', "on the AWS website."))), isInstalled ? (0, _preact.h)(GeneratedAccessKeys, {
    onClickCopy: onClickCopy,
    credentials: credentials,
    onClickUninstall: onClickUninstall,
    isAthenaDataAvailable: isAthenaDataAvailable
  }) : (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return onGenerateAccessKeys();
    },
    onCancel: function onCancel() {},
    showCancelButton: false,
    primaryButtonVariantType: "brand",
    primaryButtonText: "Install",
    isLoading: isLoading
  }));
};

var GeneratedAccessKeys = function GeneratedAccessKeys(props) {
  var credentials = props.credentials,
      onClickCopy = props.onClickCopy,
      onClickUninstall = props.onClickUninstall,
      isAthenaDataAvailable = props.isAthenaDataAvailable;
  return (0, _preact.h)("div", null, (credentials === null || credentials === void 0 ? void 0 : credentials.secret) && (0, _preact.h)(_Message.Message, {
    variant: "warning"
  }, (0, _preact.h)("div", null, (0, _preact.h)("p", null, "Secret access key will not be shown again after you leave this page. Make sure you copy and store secret access key. Keep your credentials secure. Publicly exposing your credentials can result in your account being compromised."))), !isAthenaDataAvailable && (0, _preact.h)(_InputGroup.default, {
    title: "Access key ID",
    newStyle: true,
    customInput: (0, _preact.h)("div", {
      className: "input-group-form"
    }, (0, _preact.h)("input", {
      className: "form-control qa-access-key-id",
      value: credentials === null || credentials === void 0 ? void 0 : credentials.id,
      disabled: true
    }), (0, _preact.h)(_Button.default, {
      size: "medium",
      variant: "brand",
      title: "Copy",
      onClick: function onClick() {
        return onClickCopy('id');
      },
      className: "qa-copy"
    })),
    id: "AccessKeyID"
  }), (credentials === null || credentials === void 0 ? void 0 : credentials.secret) && (0, _preact.h)(_InputGroup.default, {
    title: "Secret access key",
    newStyle: true,
    customInput: (0, _preact.h)("div", {
      className: "input-group-form"
    }, (0, _preact.h)("input", {
      className: "form-control qa-secret-access-key",
      value: credentials === null || credentials === void 0 ? void 0 : credentials.secret,
      disabled: true
    }), (0, _preact.h)(_Button.default, {
      size: "medium",
      variant: "brand",
      title: "Copy",
      onClick: function onClick() {
        return onClickCopy('secret');
      },
      className: "qa-copy"
    })),
    id: "AccessKey"
  }), (0, _preact.h)("div", {
    className: "panel-buttons-container"
  }, (0, _preact.h)(_Button.default, {
    size: "medium",
    variant: "warning",
    title: "Uninstall",
    onClick: function onClick() {
      return onClickUninstall();
    },
    className: "integration__button_uninstall qa-integration-uninstall"
  })));
};

var GeneratedAccessKeysV2 = function GeneratedAccessKeysV2(props) {
  var credentials = props.credentials,
      onClickCopy = props.onClickCopy,
      isAthenaDataAvailable = props.isAthenaDataAvailable;
  return (0, _preact.h)("div", null, (credentials === null || credentials === void 0 ? void 0 : credentials.secret) && (0, _preact.h)(_Message.Message, {
    variant: "warning"
  }, (0, _preact.h)("div", null, (0, _preact.h)("p", null, (0, _preact.h)("strong", null, "IMPORTANT: "), " Copy and Securely Store your Secret Access Key NOW. This key will not be displayed ever again after you leave. Keep your credentials secure, publicly exposing your credentials can result in your account being compromised."))), !isAthenaDataAvailable && (0, _preact.h)(_InputGroup.default, {
    title: "Access key ID",
    newStyle: true,
    customInput: (0, _preact.h)("div", {
      className: "input-group-form"
    }, (0, _preact.h)("input", {
      className: "form-control qa-access-key-id",
      value: credentials === null || credentials === void 0 ? void 0 : credentials.id,
      disabled: true
    }), (0, _preact.h)(_Button.default, {
      size: "medium",
      variant: "brand",
      title: "Copy",
      onClick: function onClick() {
        return onClickCopy('id');
      },
      className: "qa-copy"
    })),
    id: "AccessKeyID"
  }), (credentials === null || credentials === void 0 ? void 0 : credentials.secret) && (0, _preact.h)(_InputGroup.default, {
    title: "Secret access key",
    newStyle: true,
    customInput: (0, _preact.h)("div", {
      className: "input-group-form"
    }, (0, _preact.h)("input", {
      className: "form-control qa-secret-access-key",
      value: credentials === null || credentials === void 0 ? void 0 : credentials.secret,
      disabled: true
    }), (0, _preact.h)(_Button.default, {
      size: "medium",
      variant: "brand",
      title: "Copy",
      onClick: function onClick() {
        return onClickCopy('secret');
      },
      className: "qa-copy"
    })),
    id: "AccessKey"
  }));
};

var InstallationPanelBodyV2 = function InstallationPanelBodyV2(props) {
  var _props$appName2 = props.appName,
      appName = _props$appName2 === void 0 ? 'Gainsight Communities Data Lake Connector' : _props$appName2,
      isInstalled = props.isInstalled,
      isLoading = props.isLoading,
      credentials = props.credentials,
      onGenerateAccessKeys = props.onGenerateAccessKeys,
      onClickUninstall = props.onClickUninstall,
      onClickCopy = props.onClickCopy,
      isAthenaDataAvailable = props.isAthenaDataAvailable,
      isInstallButtonDisabled = props.isInstallButtonDisabled;
  return (0, _preact.h)("div", {
    className: "panel-body-container installation__panel_body"
  }, isInstalled ? (0, _preact.h)(GeneratedAccessKeysV2, {
    onClickCopy: onClickCopy,
    credentials: credentials,
    onClickUninstall: onClickUninstall,
    isAthenaDataAvailable: isAthenaDataAvailable
  }) : (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "panel-body-title"
  }, "To connect to ", appName, " you will need to generate:"), (0, _preact.h)("div", {
    className: "panel-body-description"
  }, (0, _preact.h)("ul", {
    className: "panel-body-description-unordered-list"
  }, (0, _preact.h)("li", null, "Amazon Web Services (AWS) access keys (access key ID and secret access key). For more information, see", ' ', (0, _preact.h)("a", {
    href: "https://docs.aws.amazon.com/IAM/latest/UserGuide/security-creds.html#access-keys-and-secret-access-keys",
    target: "_blank",
    rel: "noreferrer",
    className: "overview-page-link"
  }, "Access keys"), ' ', "on the AWS website."))), (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: onGenerateAccessKeys,
    onCancel: function onCancel() {},
    showCancelButton: false,
    primaryButtonVariantType: "brand",
    primaryButtonText: "Install",
    isLoading: isLoading,
    isPrimaryDisabled: isInstallButtonDisabled
  })));
};

exports.InstallationPanelBodyV2 = InstallationPanelBodyV2;
var _default = InstallationPanelBody;
exports.default = _default;